import { Routes } from '@angular/router';

export const consultasRoutes: Routes = [
    {
      path: 'con_inicio',
      loadComponent: () => import('./inicio/consultas.component'),
      data: {
        codmod: 'CON',
        icon: 'home',
      },
    },
    {
      path: "con_datos-empleados",
      loadChildren: () =>
          import("./datos-empleados/datos-empleados.routes").then(
          (m) => m.datosEmpleadosRoutes
        ),
      data: {
        codmod: "CON",
        icon: "group",
      },
    },
    {
      path: "con_novedades_liquidacion",
      loadChildren: () =>
          import("./novedades-liquidacion/novedades-liquidacion.routes").then(
          (m) => m.novedadesLiquidacionRoutes
        ),
      data: {
        codmod: "CON",
        icon: "group",
      },
    },
]